/*
 * PERF: extracted from two inline <script> blocks that sat at the very top of
 * <head>, ABOVE <meta charset>. That pushed the charset declaration past the
 * first 1024 bytes of the document (browsers must find it there) and blocked
 * the parser before a single byte of CSS had been discovered.
 *
 * Loaded with `defer` from theme.liquid instead. Cacheable across pages.
 */
(function () {
  'use strict';

  var SEARCH_ICON_SELECTOR =
    '.header__icon-list a[href*="/customer_authentication/redirect"]';

  function accountIconMarkup(strokeWidth, size) {
    return (
      '<a id="kp-account33" class="custom-account-icon" href="#" style="display:inline-flex;align-items:center;">' +
      '<svg role="presentation" stroke-width="' + strokeWidth + '" focusable="false" width="' + size + '" height="' + size + '" viewBox="0 0 22 22">' +
      '<circle cx="11" cy="7" r="4" fill="none" stroke="currentColor"></circle>' +
      '<path d="M3.5 19c1.421-2.974 4.247-5 7.5-5s6.079 2.026 7.5 5" fill="none" stroke="currentColor" stroke-linecap="round"></path>' +
      '</svg></a>'
    );
  }

  function init() {
    var config = window.customAccountIcon || {};
    var anchor = document.querySelector(SEARCH_ICON_SELECTOR);

    if (!anchor) return;
    if (document.getElementById('kp-account33')) return;

    anchor.insertAdjacentHTML(
      'afterend',
      accountIconMarkup(config.strokeWidth || 1, config.size || 22)
    );

    var link = document.getElementById('kp-account33');
    if (!link) return;

    if (config.customerLoggedIn) {
      link.setAttribute('href', '/account');
    } else {
      link.setAttribute('href', '#');
      link.addEventListener('click', function (e) {
        e.preventDefault();
        if (typeof window.shipRocketMarketingLogin === 'function') {
          window.shipRocketMarketingLogin();
        } else {
          window.location.href = '/account/login';
        }
      });
    }

    // The original theme's account link is replaced by the custom one above.
    anchor.remove();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();